import { render, staticRenderFns } from "./Sendbar.vue?vue&type=template&id=186612fc&scoped=true&"
import script from "./Sendbar.vue?vue&type=script&lang=js&"
export * from "./Sendbar.vue?vue&type=script&lang=js&"
import style0 from "./Sendbar.vue?vue&type=style&index=0&id=186612fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186612fc",
  null
  
)

export default component.exports